import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';
import { buscarProductosConfiguracion } from '../../actions/configuracion';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    control: (provided) => ({ ...provided, paddingTop: '5px', paddingBottom: '5px' }),
    valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '10px' }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const opcionesStatus = [
    { value: true, label: 'Realizada' },
    { value: false, label: 'Cancelada' }
];

const opcionesTipo = [
    { value: 'normal',    label: 'Normal' },
    { value: 'cortesia',  label: 'Cortesía' },
    { value: 'especial',  label: 'Precio especial' }
];

const FiltrosVenta = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const dispatch = useDispatch();

    const sucursalesListado  = useSelector(state => state.sucursales.listado);
    const metodosListado     = useSelector(state => state.metodos.listado);
    const empleadosListado   = useSelector(state => state.empleados.listado);
    const eventosListado     = useSelector(state => state.eventos.listado);
    const productosListado   = useSelector(state => state.configuracion.productos.listado);

    const [folio, setFolio] = useState('');
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [statusData, setStatusData] = useState(null);
    const [sucursalData, setSucursalData] = useState(null);
    const [metodoData, setMetodoData] = useState(null);
    const [vendedorData, setVendedorData] = useState(null);
    const [eventoData, setEventoData] = useState(null);
    const [tipoData, setTipoData] = useState(null);
    const [productosData, setProductosData] = useState([]);

    useEffect(() => {
        dispatch(buscarProductosConfiguracion());
        if (show) {
            setFolio(filtros.folio || '');
            setFechaInicio(filtros.fecha_inicio ? new Date(filtros.fecha_inicio) : null);
            setFechaFin(filtros.fecha_fin ? new Date(filtros.fecha_fin) : null);
            setStatusData(filtros.status !== null ? opcionesStatus.find(o => o.value === filtros.status) ?? null : null);

            const sucOpc = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
            setSucursalData(filtros.sucursal ? sucOpc.find(s => s.value === filtros.sucursal) ?? null : null);

            const metOpc = metodosListado.map(m => ({ value: m._id, label: m.nombre }));
            setMetodoData(filtros.metodo ? metOpc.find(m => m.value === filtros.metodo) ?? null : null);

            const empOpc = empleadosListado.map(e => ({
                value: e._id,
                label: `${e.nombre || ''} ${e.apellido_paterno || ''} ${e.apellido_materno || ''}`.trim()
            }));
            setVendedorData(filtros.vendedor ? empOpc.find(e => e.value === filtros.vendedor) ?? null : null);

            const evOpc = eventosListado.map(e => ({ value: e._id, label: e.nombre }));
            setEventoData(filtros.evento ? evOpc.find(e => e.value === filtros.evento) ?? null : null);

            setTipoData(filtros.tipo ? opcionesTipo.find(o => o.value === filtros.tipo) ?? null : null);

            const prodOpc = productosListado.map(p => ({ value: p._id, label: p.nombre }));
            setProductosData(
                filtros.productos?.length > 0
                    ? prodOpc.filter(p => filtros.productos.includes(p.value))
                    : []
            );
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            folio: folio.trim(),
            fecha_inicio: fechaInicio ? new Date(new Date(fechaInicio).setHours(0, 0, 0, 0)) : null,
            fecha_fin: fechaFin ? new Date(new Date(fechaFin).setHours(23, 59, 59, 999)) : null,
            status: statusData ? statusData.value : null,
            sucursal: sucursalData ? sucursalData.value : null,
            metodo: metodoData ? metodoData.value : null,
            vendedor: vendedorData ? vendedorData.value : null,
            evento: eventoData ? eventoData.value : null,
            tipo:      tipoData ? tipoData.value : null,
            productos: productosData.map(p => p.value)
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        setFolio('');
        setFechaInicio(null);
        setFechaFin(null);
        setStatusData(null);
        setSucursalData(null);
        setMetodoData(null);
        setVendedorData(null);
        setEventoData(null);
        setTipoData(null);
        setProductosData([]);
        handleAplicar({ folio: '', fecha_inicio: null, fecha_fin: null, status: null, sucursal: null, metodo: null, vendedor: null, evento: null, tipo: null, productos: [] });
        handleCerrar();
    };

    const sucursalesOpciones = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
    const productosOpciones  = productosListado.map(p => ({ value: p._id, label: p.nombre }));
    const metodosOpciones = metodosListado.map(m => ({ value: m._id, label: m.nombre }));
    const vendedoresOpciones = empleadosListado.map(e => ({
        value: e._id,
        label: `${e.nombre || ''} ${e.apellido_paterno || ''} ${e.apellido_materno || ''}`.trim()
    }));
    const eventosOpciones = eventosListado.map(e => ({ value: e._id, label: e.nombre }));

    return (
        <Modal show={show} size="lg" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">

                    <div className="col-3">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Folio"
                                id="filtro_folio"
                                value={folio}
                                onChange={e => setFolio(e.target.value)}
                            />
                            <label htmlFor="filtro_folio">Folio</label>
                        </div>
                    </div>

                    <div className="col-3 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Status"
                                options={opcionesStatus}
                                value={statusData}
                                onChange={option => setStatusData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_inicio"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaInicio}
                                    onChange={date => setFechaInicio(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_inicio">Fecha inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_fin"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaFin}
                                    onChange={date => setFechaFin(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                    minDate={fechaInicio}
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_fin">Fecha fin</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Sucursal"
                                options={sucursalesOpciones}
                                value={sucursalData}
                                onChange={option => setSucursalData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Método de pago"
                                options={metodosOpciones}
                                value={metodoData}
                                onChange={option => setMetodoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Evento"
                                options={eventosOpciones}
                                value={eventoData}
                                onChange={option => setEventoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-8 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Vendedor"
                                options={vendedoresOpciones}
                                value={vendedorData}
                                onChange={option => setVendedorData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Tipo"
                                options={opcionesTipo}
                                value={tipoData}
                                onChange={option => setTipoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-12 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Productos"
                                options={productosOpciones}
                                value={productosData}
                                onChange={opts => setProductosData(opts || [])}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isMulti
                                isClearable
                            />
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosVenta;
